import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';
import type { ClientProfile } from '../types/clientProfile';
import type { UpdateUserMeRequest, UserMeUpdateResponseDto } from '../types/auth';
import type { LanguageCode } from '../types/i18n';

export const clientProfileApi = {
  getProfile: async (): Promise<ClientProfile> => {
    const res = await apiClient.get<ApiResponse<ClientProfile>>(API_PATHS.CLIENT_PROFILE);
    return res.data.data;
  },

  updateMe: async (
    tenantId: number,
    req: UpdateUserMeRequest,
  ): Promise<UserMeUpdateResponseDto> => {
    const res = await apiClient.put<ApiResponse<UserMeUpdateResponseDto>>(
      API_PATHS.userMeUpdate(tenantId),
      req,
    );
    return res.data.data;
  },

  updateLanguage: async (languageCode: LanguageCode): Promise<void> => {
    await apiClient.patch(API_PATHS.CLIENT_LANGUAGE_UPDATE, { languageCode });
  },
};
